var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D27A2D",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.382 11.019a.813.813 0 0 0-.31-.338.889.889 0 0 0-.455-.128h-1.335a.268.268 0 0 1-.183-.071.236.236 0 0 1-.075-.172V6.183c0-.1-.033-.197-.094-.279a.515.515 0 0 0-.248-.178.571.571 0 0 0-.313-.01.544.544 0 0 0-.266.156L7.65 12.155a.753.753 0 0 0-.124.845.814.814 0 0 0 .31.338.89.89 0 0 0 .455.128h1.335c.068 0 .134.026.183.071a.235.235 0 0 1 .075.172v4.127c0 .1.033.197.094.279a.515.515 0 0 0 .248.177c.058.01.117.01.176 0a.578.578 0 0 0 .403-.175l5.452-6.283a.752.752 0 0 0 .124-.816Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.b32ce38fc51c9b4c81897406fad505c2.svg";
export { ForwardRef as ReactComponent };